export const WalkthroughContainer = () => {
    return null;
};

export default WalkthroughContainer;
